import { observer } from "mobx-react-lite";
import React, { useMemo } from "react";
import { Label, FormGroup } from "reactstrap";
import { Asterisk } from "../../components/Asterisk";
import { Option } from "./Option";
import { Text } from "./Text";

export const Question = observer((props) => {
  const { settings, environment, questions, validations, contentModuleId, contentLayoutModuleId } = props;
  const { questionId, prefixClassName, type, validation, groupTransfer, hidden } = settings;

  const question = questions.find((q) => q.questionId == questionId);
  if (!question) return null;

  const label = question?.questionLanguage?.find((fl) => fl.languageCode == environment.lang)?.label;
  const subLabel = question?.questionLanguage?.find((fl) => fl.languageCode == environment.lang)?.subLabel;

  const validity = useMemo(() => validations.find((v) => v.id == contentModuleId), [validations, contentModuleId]);

  if (hidden) return null;
  return (
    <>
      {type == "option" ? (
        <FormGroup className={settings?.imitateField ? "cms-field" : prefixClassName}>
          {!settings?.hideLabel && (
            <div className="title-holder">
              <Label className={prefixClassName}>
                {label}
                {question.requiredMin > 0 ? <Asterisk /> : null}
              </Label>
              {subLabel ? <Label className="sublabel">{subLabel}</Label> : null}
            </div>
          )}
          <Option {...{ ...props, question, validity }} />
        </FormGroup>
      ) : (
        <Text {...{ ...props, validity, settings, label, question, subLabel }} />
      )}
    </>
  );
});
